import { defineMessages } from 'react-intl';

/** The Earnings block, the Earnings section and the member card (design e1, e2, e3). */
export const streamingEarningsMessages = defineMessages({
  title: { id: 'app.sml.streaming.earnings.title', defaultMessage: 'Earnings' },
  seeEarnings: { id: 'app.sml.streaming.earnings.see', defaultMessage: 'See earnings' },
  netPeriod: { id: 'app.sml.streaming.earnings.netPeriod', defaultMessage: 'Net, {start} – {end}' },
  net: { id: 'app.sml.streaming.earnings.net', defaultMessage: 'Net' },
  gross: { id: 'app.sml.streaming.earnings.gross', defaultMessage: 'Gross' },
  currencyLine: {
    id: 'app.sml.streaming.earnings.currencyLine',
    defaultMessage: 'As reported by {source}. Amounts in {currency}.',
  },
  noCurrencyLine: {
    id: 'app.sml.streaming.earnings.noCurrencyLine',
    defaultMessage: 'As reported by {source}. The source did not say the currency.',
  },
  report: {
    id: 'app.sml.streaming.earnings.report',
    defaultMessage: 'As reported by {source} for {start} – {end}. Last read {date}.',
  },
  inThisPeriod: { id: 'app.sml.streaming.earnings.inPeriod', defaultMessage: 'Earnings in this period' },
  changeNet: { id: 'app.sml.streaming.earnings.changeNet', defaultMessage: '{change} net' },
  perMonth: { id: 'app.sml.streaming.earnings.perMonth', defaultMessage: 'Net per month' },
  perMonthNote: {
    id: 'app.sml.streaming.earnings.perMonthNote',
    defaultMessage: 'Whole calendar months that your plan shows.',
  },
  byStore: { id: 'app.sml.streaming.earnings.byStore', defaultMessage: 'By store' },
  byTrack: { id: 'app.sml.streaming.earnings.byTrack', defaultMessage: 'By track' },
  byCountry: { id: 'app.sml.streaming.earnings.byCountry', defaultMessage: 'By country' },
  units: { id: 'app.sml.streaming.earnings.units', defaultMessage: 'Units' },
  otherCurrency: {
    id: 'app.sml.streaming.earnings.otherCurrency',
    defaultMessage: 'Amounts in {currency}. You changed the currency on {source}, so MUSIC24 shows them apart.',
  },
  otherNoCurrency: {
    id: 'app.sml.streaming.earnings.otherNoCurrency',
    defaultMessage: 'Amounts with no currency. MUSIC24 shows them apart.',
  },
  noBank: {
    id: 'app.sml.streaming.earnings.noBank',
    defaultMessage: 'MUSIC24 shows amounts only. It does not read or show bank or payout details.',
  },
  hiddenTitle: {
    id: 'app.sml.streaming.earnings.hidden.title',
    defaultMessage: 'Only the workspace owner can see earnings',
  },
  hiddenText: {
    id: 'app.sml.streaming.earnings.hidden.text',
    defaultMessage:
      'Earnings are private to the owner of this workspace. Streams, stores, countries and playlists are all here for you.',
  },
  hiddenHint: {
    id: 'app.sml.streaming.earnings.hidden.hint',
    defaultMessage: 'The owner can turn on "Members can see earnings" in Settings → Team.',
  },
  noSourceTitle: {
    id: 'app.sml.streaming.earnings.noSource.title',
    defaultMessage: 'No earnings to show',
  },
  noSourceText: {
    id: 'app.sml.streaming.earnings.noSource.text',
    defaultMessage:
      'Streaming shows the earnings that your connected sources report. Sources that report earnings: {sources}.',
  },
  nothingTitle: {
    id: 'app.sml.streaming.earnings.nothing.title',
    defaultMessage: 'No earnings reported for this period',
  },
  nothingText: {
    id: 'app.sml.streaming.earnings.nothing.textAny',
    defaultMessage: 'No earnings reported for {start} – {end} yet. Pick a longer period.',
  },
  noWholeMonth: {
    id: 'app.sml.streaming.earnings.noWholeMonthAny',
    defaultMessage: 'Earnings come by calendar month. Pick a longer period to see them.',
  },
  colGross: { id: 'app.sml.streaming.earnings.col.gross', defaultMessage: 'Gross' },
  colNet: { id: 'app.sml.streaming.earnings.col.net', defaultMessage: 'Net' },
  colNetEarnings: { id: 'app.sml.streaming.earnings.col.netEarnings', defaultMessage: 'Net earnings' },
  planTitle: { id: 'app.sml.streaming.earnings.plan.title', defaultMessage: 'See what each store pays you' },
  splitPlanTitle: {
    id: 'app.sml.streaming.split.plan.title',
    defaultMessage: 'See which stores and countries stream you',
  },
  planLine: { id: 'app.sml.streaming.plan.line', defaultMessage: 'On {plan}, {price} a month.' },
  planLineNoPrice: { id: 'app.sml.streaming.plan.lineNoPrice', defaultMessage: 'On the {plan} plan.' },
  planUpgrade: { id: 'app.sml.streaming.plan.upgrade', defaultMessage: 'See the plan' },
  planLockedColumn: {
    id: 'app.sml.streaming.earnings.plan.column',
    defaultMessage: 'Earnings are on a paid plan',
  },
});
